<div class="entity-config-page container-fluid">
  <div class="entity-config-shell d-flex flex-column gap-0 mx-auto">
    <section class="entity-config-top rounded-4 overflow-hidden shadow-sm mb-0 mt-4">
      <div class="entity-config-top-hero px-2 px-md-2 pt-2 pb-2">
        <div class="row g-2 align-items-start">
          <div class="col">
            <div class="text-uppercase text-xxs text-white opacity-75 d-flex align-items-center gap-2 mb-2">
              <span>Handler</span>
              <span>/</span>
              <span>Reports</span>
            </div>
            <h1 class="entity-page-title text-white fw-bold lh-sm">{{ page_title }}</h1>
          </div>
        </div>
      </div>
    </section>

    <section class="row g-0">
      <div class="col-12 p-0 m-0">
        <div class="entity-detail-panel entity-detail-panel-vibrant rounded-4 border shadow-sm p-3 h-100 mt-0">
          <div class="d-flex flex-wrap gap-2 mb-3">
            <button
              v-for="filter in filters"
              :key="filter.key"
              type="button"
              class="btn btn-sm rounded-pill px-3"
              :class="active_filter === filter.key ? 'btn-primary-dark' : 'btn-light border secondary-color'"
              @click="set_filter(filter.key)"
            >
              {{ filter.label }}
            </button>
          </div>

          <div class="row g-3">
            <div v-for="report in filtered_reports" :key="report.id" class="col-12 col-xl-6">
              <article class="entity-vibrant-binding-card rounded-4 bg-white border shadow-sm p-3 h-100">
                <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                  <div class="flex-grow-1">
                    <span class="badge rounded-2 fw-normal mb-3" :class="report.category_badge_class">
                      {{ report.category_label }}
                    </span>
                    <h2 class="fs-5 fw-bold text-dark mb-2">{{ report.title }}</h2>
                    <div class="small text-secondary">{{ report.description }}</div>
                  </div>

                  <button
                    type="button"
                    class="btn btn-light btn-sm rounded-small border entity-audit-btn px-3 flex-shrink-0 mt-4"
                    @click="open_report_modal(report)"
                  >
                    {{ report.action_label }} <i class="bi bi-arrow-right"></i>
                  </button>
                </div>
              </article>
            </div>

            <div v-if="!filtered_reports.length" class="col-12">
              <div class="entity-vibrant-binding-card rounded-4 bg-white border shadow-sm p-4 text-center text-secondary small">
                No reports match this filter.
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-3">
            <article class="entity-vibrant-binding-card rounded-4 p-3 bg-primary text-white col-12 col-xl-4">
              <div class="text-uppercase text-xxs opacity-75 mb-2">X-Verdict</div>
              <div class="small fw-semibold lh-base">
                {{ info_callout }}
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<div
  v-if="report_modal_open && selected_report"
  class="report-run-modal-backdrop"
  @click.self="close_report_modal"
>
  <div class="report-run-modal-dialog">
    <div class="modal-content bg-white rounded-4 p-0 shadow-lg overflow-hidden report-run-modal-content">
      <div class="report-run-modal-header d-flex align-items-start justify-content-between gap-3">
        <div>
          <div class="report-run-modal-title">Run &middot; {{ selected_report.title }}</div>
          <div class="report-run-modal-subtitle">Choose the parameters and export format</div>
        </div>

        <button
          type="button"
          class="btn-close modal-btn-close report-run-modal-close"
          aria-label="Close"
          @click="close_report_modal"
        ></button>
      </div>

      <div class="report-run-modal-body">
        <div class="mb-3">
          <label class="case-owner-new-case-label text-uppercase mb-2">Date range</label>
          <select v-model="selected_date_range" class="form-select case-owner-new-case-control report-run-select">
            <option
              v-for="option in report_date_ranges"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="mb-3">
          <label class="case-owner-new-case-label text-uppercase mb-2">Scope</label>
          <select v-model="selected_scope" class="form-select case-owner-new-case-control report-run-select">
            <option
              v-for="option in report_scopes"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>

        <div>
          <label class="case-owner-new-case-label text-uppercase mb-2">Format</label>
          <div class="report-run-format-grid">
            <button
              v-for="option in report_formats"
              :key="option.value"
              type="button"
              class="report-run-format-card text-start"
              :class="{ 'is-active': selected_format === option.value }"
              @click="selected_format = option.value"
            >
              <div class="d-flex align-items-start gap-3">
                <span class="report-run-format-radio" :class="{ 'is-active': selected_format === option.value }"></span>
                <div>
                  <div class="report-run-format-title">{{ option.label }}</div>
                  <div class="report-run-format-subtitle">{{ option.description }}</div>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>

      <div class="report-run-modal-footer d-flex justify-content-end gap-2">
        <button
          type="button"
          class="btn btn-light btn-sm rounded-small border px-4"
          @click="close_report_modal"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary-dark btn-sm rounded-small px-4"
          @click="generate_report"
        >
          Generate
        </button>
      </div>
    </div>
  </div>
</div>
